import { useCallback } from "react";
import { useOrderDraft } from "../../context/OrderDraftContext";
import { Kit } from "../../types/order.types";

// A IA só recomenda quando o médico pede (gasta tokens). O id recomendado fica no rascunho,
// por lista e caso: voltar à aba mostra a recomendação sem chamar a IA de novo.
export const useKitRecommendation = (list: string) => {
  const { newInputRequest, laudoText, kitRecommendations, setKitRecommendations } = useOrderDraft();
  // ponytail: a chave leva o histórico e o laudo inteiros; mudou o caso, a recomendação antiga deixa de valer.
  const key = [list, newInputRequest, laudoText].join("\n");
  const id = kitRecommendations[key];

  const remember = useCallback(
    (kitId: number) => setKitRecommendations((prev) => ({ ...prev, [key]: kitId })),
    [key, setKitRecommendations]
  );
  const mark = <T,>(kits: Kit<T>[]) => kits.map((k) => ({ ...k, recommended: k.id === id }));

  return { remember, mark };
};
